<div
    *ngIf="featuredResources && featuredResources.length > 0"
    class="container-fluid selenium-app-featured"
>
    <div class="row">
        <app-carousel2
            [itemWidth]="240"
            [alwaysShowArrows]="false"
            [innerArrows]="true"
            height="410"
            [gtmPrefix]="gtmPrefix"
        >
            <app-carousel-item2 *ngFor="let resource of featuredResources">
                <app-resource-featured-card
                    [headerURL]="getBrowseURL(resource)"
                    [resource]="resource"
                    [gtmPrefix]="gtmPrefix"
                ></app-resource-featured-card>
            </app-carousel-item2>
        </app-carousel2>
    </div>
</div>
